class ButtonHoverAnimation {
  constructor(selector = '.button') {
    this.selector = selector;
    this.FALLBACK_MS = 450; // overlay transition duration + buffer
    this.init();
  }

  init() {
    document.querySelectorAll(this.selector).forEach(button => {
      const overlay = button.querySelector('.button__overlay');
      if (!overlay) return; // skip if no overlay

      // Skip if already initialized
      if (button._btnAnimState) return;

      button._btnAnimState = { resetTimer: null };

      button.addEventListener('mouseenter', () => this.start(button));
      button.addEventListener('focus', () => this.start(button));
      button.addEventListener('mouseleave', () => this.stop(button, overlay));
      button.addEventListener('blur', () => this.stop(button, overlay));
    });
  }

  /** Hover in */
  start(button) {
    this._clear(button);
    button.classList.remove('animate-out', 'animate-reset');
    button.classList.add('animate-in');
  }

  /** Hover out */
  stop(button, overlay) {
    this._clear(button);

    button.classList.remove('animate-in', 'animate-reset');
    button.classList.add('animate-out');

    const onEnd = (e) => {
      if (e.propertyName !== 'transform') return;
      this._doReset(button);
    };

    overlay.addEventListener('transitionend', onEnd, { once: true });

    // Fallback in case transitionend never fires
    button._btnAnimState.resetTimer = setTimeout(() => {
      overlay.removeEventListener('transitionend', onEnd);
      this._doReset(button);
    }, this.FALLBACK_MS);
  }

  /** Reset back to idle */
  _doReset(button) {
    this._clear(button);
    button.classList.remove('animate-in', 'animate-out');
    button.classList.add('animate-reset');

    // Remove reset class shortly after so we end at a clean baseline
    button._btnAnimState.resetTimer = setTimeout(() => {
      button.classList.remove('animate-reset');
      button._btnAnimState.resetTimer = null;
    }, 20);
  }

  /** Cancel any pending timers */
  _clear(button) {
    if (button._btnAnimState.resetTimer) {
      clearTimeout(button._btnAnimState.resetTimer);
      button._btnAnimState.resetTimer = null;
    }
  }
}

// Initialize on page load
let buttonAnimation;

document.addEventListener('DOMContentLoaded', () => {
  buttonAnimation = new ButtonHoverAnimation('.button, .js-webform-button-wrapper');
});

// Track the last clicked wrapper
document.addEventListener('click', (e) => {
  const wrapper = e.target.closest('.js-webform-button-wrapper');
  if (wrapper) {
    document.querySelectorAll('.js-webform-button-wrapper').forEach(el => el.classList.remove('is-clicked'));
    wrapper.classList.add('is-clicked');
    
    // Fallback: clear the is-clicked class after a few seconds if no AJAX happens
    setTimeout(() => wrapper.classList.remove('is-clicked'), 2000);
  }
}, true);

// Handle standard form submissions (non-AJAX)
document.addEventListener('submit', (e) => {
  const form = e.target;
  const clickedWrapper = form.querySelector('.js-webform-button-wrapper.is-clicked') || form.querySelector('.js-webform-button-wrapper');
  if (clickedWrapper) {
    clickedWrapper.classList.add('is-loading');
  }
});

// Reinitialize after Drupal AJAX events (for webforms and other AJAX forms)
if (typeof Drupal !== 'undefined' && Drupal.behaviors) {
  Drupal.behaviors.buttonAnimation = {
    attach: function (context) {
      if (buttonAnimation) {
        buttonAnimation.init();
      } else {
        buttonAnimation = new ButtonHoverAnimation('.button, .js-webform-button-wrapper');
      }
    }
  };

  // Handle Drupal AJAX events to toggle loading state
  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('ajaxSend', function(event, xhr, options) {
      // Find the specific button wrapper that was clicked
      const clickedWrapper = document.querySelector('.js-webform-button-wrapper.is-clicked');
      if (clickedWrapper) {
         clickedWrapper.classList.add('is-loading');
      } else {
         // Fallback if we couldn't track the click
         const $activeForm = jQuery(document.activeElement).closest('form');
         const $wrapper = $activeForm.find('.js-webform-button-wrapper');
         if ($wrapper.length) {
           $wrapper.addClass('is-loading');
         }
      }
    });

    jQuery(document).on('ajaxComplete', function(event, xhr, settings) {
      // Remove loading state on ajax complete in case there's an error 
      // and the button is not replaced by a new form.
      document.querySelectorAll('.js-webform-button-wrapper.is-loading').forEach(el => {
        el.classList.remove('is-loading');
      });
    });
  }
}
